<style lang="less" scoped>
    .margin-tb{
        height:32px;
        margin-top: 4px;
    }
</style>

<template>
    <div class="list-container">
        <div class="list-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
        </div>
        <div class="list-content-div">
            <div class="list-header-title-div">客户管理</div>
            <!-- <div class="page-title-div">电站管理</div> -->
            <ZD-list-querys>
                <template slot="inputs">
                    <!-- <div class="list-query-child-div flex">
                        <div class="query-title-div">运营商名称</div>
                        <div class="query-inputs-div flex-1">
                            <el-input size="small" v-model="queryInfo.dealerName" placeholder="请输入内容" clearable></el-input>
                        </div>
                    </div>
                    <div class="list-query-child-div flex">
                        <div class="query-title-div">运营商编号</div>
                        <div class="query-inputs-div flex-1">
                            <el-input size="small" v-model="queryInfo.dealerNo" placeholder="请输入内容" clearable></el-input>
                        </div>
                    </div> -->
                    <div class="list-query-child-div flex">
                        <div class="query-title-div">注册时间</div>
                        <div class="query-inputs-div flex-1">
                             <el-date-picker v-model="searchTime" style="width:320px;" type="daterange" size="small" value-format="yyyy-MM-dd" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" @change="handleDateChange"></el-date-picker>
                        </div>
                    </div>
                    <div class="list-query-child-div flex">
                        <div class="query-title-div">手机号</div>
                        <div class="query-inputs-div flex-1">
                            <!-- <el-select class="full-width" v-model="queryInfo.mobile" filterable size="small" clearable remote reserve-keyword :remote-method="getMobileArr" placeholder="请输入4位或4位以上手机号">
                                <el-option v-for="item in mobileArr" :key="item.mobile" :label="item.mobile" :value="item.mobile"></el-option>
                            </el-select> -->
                            <el-input size="small" v-model="queryInfo.mobile" placeholder="请输入内容" clearable @keyup.enter.native="getListData(pagination,true)"></el-input>
                        </div>
                    </div>
                    <div class="list-query-child-div flex">
                        <div class="query-title-div">客户标签</div>
                        <div class="query-inputs-div flex-1">
                            <el-select size="small" v-model="queryInfo.custType" clearable class="full-width">
                                <el-option v-for="(item,index) in labelsArr" :key="index" :value="item.configName">{{item.configName}}</el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="list-query-child-div flex">
                        <div class="query-title-div">首次充电</div>
                        <div class="query-inputs-div flex-1">
                             <el-date-picker v-model="firstSearchTime" style="width:320px;" type="daterange" size="small" value-format="yyyy-MM-dd 00:00:00" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" @change="firstHandleDateChange"></el-date-picker>
                        </div>
                    </div>
                    <div class="list-query-child-div flex">
                        <div class="query-title-div">最近充电</div>
                        <div class="query-inputs-div flex-1">
                             <el-date-picker v-model="lastSearchTime" style="width:320px;" type="daterange" size="small" value-format="yyyy-MM-dd 00:00:00" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" @change="lastHandleDateChange"></el-date-picker>
                        </div>
                    </div>
                </template>
                <template  slot="actions">
                    <div class="">
                        <button class="common-bg-button" @click="getListData(pagination,true)">搜 索</button>
                        <button class="common-empty-button" @click="reset()">重 置</button>
                    </div>
                    <div class="">
                        <button class="common-bg-button" @click="toExportList" style="width:80px;margin-top:15px">导出</button>
                    </div>
                </template>
            </ZD-list-querys>
            <div class="page-action-btns flex">
                <button class="common-bg-button" @click="getLabels(true)">标签管理</button>
                <button class="common-bg-button" @click="disDealerDialog('dealerForm')">新增客户</button>
            </div>
            <!-- 表格 -->
            <div class="list-table">
                <ZD-table :tableColumns="pageConfig.listColumns" :operates="operates" :tableData="tableData" :tableConfig="pageConfig.tableConfig" :selections="selections" v-on:updateSelections="(sels)=>{selections=sels}"></ZD-table>
            </div>
            <!-- 分页 -->
            <div class="list-pagination">
                <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData"></ZD-pagination>
            </div>
        </div>
        <el-dialog title="标签管理" :visible.sync="labelVisible">
            <el-form :model="labelForm" :rules="pageConfig.labelFormRules" ref="labelForm" label-width="100px">
                <div class="flex">
                    <el-form-item  label="标签名称" prop="configName">
                        <el-input size="small" style="width:300px;margin-right:10px;" v-model="labelForm.configName"></el-input>
                    </el-form-item>
                    <!-- <el-form-item  label="编号" prop="configVal">
                        <el-input size="small" style="width:300px;margin-right:10px;" v-model="labelForm.configVal"></el-input>
                    </el-form-item> -->
                    <el-button size="small" class="margin-tb" type="primary" @click="addLabelFun('labelForm')">新增标签</el-button>
                </div>
            </el-form>
            <div style="margin-bottom:10px;">合计客户数：{{labelSum}}</div>
            <ZD-table :tableColumns="pageConfig.dialogListColumns" :operates="dialogOperates" :tableData="labelsArr" :tableConfig="pageConfig.dialogTableConfig" :selections="selections" v-on:updateSelections="(sels)=>{selections=sels}"></ZD-table>
            <!-- <span slot="footer" class="dialog-footer">
                <button class="common-empty-button" @click="dialogTableVisible = false">取 消</button>
                <button class="common-bg-button" type="primary" @click="dialogTableVisible = false">确 定</button>
            </span> -->
        </el-dialog>
        <el-dialog title="新增客户" :visible.sync="dealerVisible">
            <el-form :model="dealerForm" :rules="pageConfig.dealerFormRules" ref="dealerForm" label-width="100px">
                <div style="margin:0px 0px 20px 15px;">请提前确认该客户已经在桩到家APP中注册提交后该客户便属于运营商的客户</div>
                <!-- <el-form-item  label="运营商全称" prop="dealerNo">
                    <el-select size="small" style="width:300px;" v-model="dealerForm.dealerNo" filterable remote reserve-keyword placeholder="请输入关键词" :remote-method="remoteMethod" :loading="loading">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item  label="手机号" prop="mobile">
                    <el-input size="small" style="width:300px;" v-model="dealerForm.mobile"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <button class="common-empty-button" @click="dealerVisible = false">取 消</button>
                <button class="common-bg-button" type="primary" @click="addCustFun('dealerForm')">确 定</button>
            </span>
        </el-dialog>
        <el-dialog title="选择标签(可多选)" :visible.sync="selectLabelVisible" width="40%">
            <el-form :model="selectLabelForm" :rules="pageConfig.selectFormRules" ref="selectLabelForm">
                <el-form-item prop="dealerName">
                    <el-checkbox-group v-model="checkList">
                        <el-checkbox v-for="item in labelsArr" :key="item.id" :label="item.id">{{item.configName}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <button class="common-empty-button" @click="selectLabelVisible = false">取 消</button>
                <button class="common-bg-button" type="primary" @click="selectLabelFun()">确 定</button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import pageConfig from './page-config';
    export default {
        data() {
            return {
                pageConfig: pageConfig, // 页面配置
                tableData: [], // 表格数据
                selections: [], // 表格选项
                pagination: pageConfig.pagination,
                queryInfo: {},
                labelVisible:false,
                dealerVisible:false,
                selectLabelVisible:false,
                labelName:'11',
                labelForm:{},
                dealerForm:{},
                checkList:[],
                labelsArr:[],
                selectLabelForm:{},
                labelSum:0,
                operates: {
					width: 220,
					fixed: "right",
					list: [
						{
							id: "report",
                            label: "详情",
                            type:"primary",
							show: true,
							disabled: false,
							method: (index, row) => {
								this.$store.commit('setEditId', row.id)
								// this.$router.push({
								// 	name: pageConfig.custDeatilRouter
                                // });
                                window.open(this.$router.resolve({name: pageConfig.custDeatilRouter}).href,'_blank')
							}
						},
						{
							id: "expenses",
                            label: "标签",
                            type:"primary",
							show: true,
							disabled: false,
							method: (index, row) => {
                                this.checkList = [];
                                
                                this.selectLabelForm.mobile = row.mobile;
                                this.$H.post(this,this.$A.config.list,{configType:'187',mobile:row.mobile}).then(res => {
                                    this.labelsArr = res.data.data;
                                    this.checkList = row.custDto.custType.split(',');
                                    this.selectLabelVisible = true;
                                })
							}
                        },
					]
                }, // 列操作按钮
                dialogOperates: {
					width: 100,
					fixed: "right",
					list: [
						{
							id: "del",
                            label: "删除",
                            type:"danger",
							show: true,
							disabled: false,
							method: (index, row) => {
                                if(row.configDisp > 0){
                                    this.$U.error('标签数不为0，不可删除！');
                                    return;
                                }
                                let url = this.$A.config.config + '/' + row.id;
                                this.$U.showLoading(this);
								this.$H.del(this,url,{}).then(res => {
                                    this.getLabels(true);
                                    this.$U.hideLoading(this);
                                })
							}
						}
					]
                }, // 列操作按钮
                searchTime:[],
                firstSearchTime:[],
                lastSearchTime:[],
                options: [],
                value: [],
                list: [],
                loading: false,
                mobileArr: [],
            }
        },
        methods: {
            init() {
                this.getListData(this.pagination,true);
                this.getLabels(false);
            },
            // 获取表格数据
            getListData(pagination, reload = false) {
                let _ = this;
                _.$U.showLoading(_);
                _.queryInfo.pageNum = pagination.current - 1;
                if (reload) {
                    this.pagination.current = 1;
                    _.queryInfo.pageNum = 0;
                }
                _.queryInfo.pageSize = pagination.pageSize;
                _.queryInfo.corpNo = _.$store.state.corpNo;
                _.$H.post(_, _.$A.cust.pagecust, _.queryInfo).then(res => {
                    _.tableData = res.data.data.content || [];
                    _.pagination.total = res.data.data.totalElements || 0;
                    _.$U.hideLoading(_);
                })
            },
            getMobileArr(query){
                let _ = this
                if (query.length >= 4) {
                    //this.loading = true;
                    var obj = {
                        sort : '-mobile',
                        mobile: query 
                    }
                    _.$H.post(_, _.$A.cust.findCustPhoneList,obj).then(res => {
                            _.mobileArr = res.data.data
                    })
                } else {
                    this.mobileArr = [];
                }
            },
            handleDateChange(val){
                if(val){
                    this.queryInfo.dtFrom = val[0];
                    this.queryInfo.dtTo = val[1];
                }else{
                    delete this.queryInfo.dtFrom;
                    delete this.queryInfo.dtTo;
                }
                
            },
            lastHandleDateChange(val){
                if(val){
                    this.queryInfo.dtFromLatest = val[0];
                    this.queryInfo.dtToLatest = val[1];
                }else{
                    delete this.queryInfo.dtFromLatest;
                    delete this.queryInfo.dtToLatest;
                }
                
            },
            firstHandleDateChange(val){
                if(val){
                    this.queryInfo.dtFromFirst = val[0];
                    this.queryInfo.dtToFirst = val[1];
                }else{
                    delete this.queryInfo.dtFromFirst;
                    delete this.queryInfo.dtToFirst;
                }
            },
            getLabels(flag){
               this.$H.post(this,this.$A.config.list,{configType:'187'}).then(res => {
                    this.labelsArr = res.data.data;
                    if(flag){
                        this.labelManageDialog();
                    }
                }) 
            },
            labelManageDialog(){
                this.labelsArr.forEach(item => {
                    this.labelSum = this.labelSum + item.configDisp;
                })
                this.labelVisible = true;
            },
            disDealerDialog(formName){
                let _ = this;
                _.$H.get(_,_.$A.cust.allDealer,{}).then(res => {
                    _.list = [];
                    res.data.data.content.forEach(item => {
                        _.list.push({ value:item.dealNo, label:item.dealName})
                    })
                    this.dealerForm = {};
                    this.dealerVisible = true;
                })
            },
            addLabelFun(formName){
                let _ = this;
                
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        _.$U.showLoading(_);
                        _.$H.post(_,_.$A.cust.addtarget,_.labelForm).then(res => {
                            _.labelManageDialog();
                            _.getLabels();
                            _.labelForm.configName = "";
                            _.$U.hideLoading(_);
                        })
                    }
                });
            },
            addCustFun(formName){
                let _ = this;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        _.$U.showLoading(_);
                        _.dealerForm.dealerNo = _.$store.state.userInfo.dealNo;
                        _.$H.post(_, _.$A.cust.addupdatecust, _.dealerForm).then(res => {
                            _.dealerVisible = false;
                            _.$U.success('分配成功');
                            _.init();
                        })
                    }
                });
            },
            selectLabelFun(){
                let _ = this;
                _.selectLabelVisible = false;
                let labelName = '';
                _.checkList.forEach(item =>{
                    labelName = labelName + item + ',';
                })
                labelName = labelName.substring(0,labelName.lastIndexOf(','));
                _.selectLabelForm.custType = labelName;
                _.selectLabelForm.editParam = 'custType';
                _.$U.showLoading(_);
                _.$H.post(_, _.$A.cust.targetremark, _.selectLabelForm).then(res => {
                    _.$U.hideLoading(_);
                    _.getListData(this.pagination);
                    _.$U.success('保存成功');
                })
            },
            remoteMethod(query) {
                if (query !== '') {
                    this.loading = true;
                    setTimeout(() => {
                        this.loading = false;
                        this.options = this.list.filter(item => {
                        return item.label.toLowerCase()
                            .indexOf(query.toLowerCase()) > -1;
                        });
                    }, 200);
                } else {
                    this.options = [];
                }
            },
            // 页面新增方法
            listAddFun() {
                this.$S.listAddFun(this, pageConfig.tableEditObj);
            },
            // 页面编辑方法
            listEditFun() {
                this.$S.listEditFun(this, this.selections, pageConfig.tableEditObj);
            },
            toExportList(){
                let _ = this;
                _.queryInfo.dealerNo = _.$store.state.userInfo.dealNo
                _.$H.post(_, _.$A.cust.exportCustList, _.queryInfo).then(res => {
                    _.$U.saveExcelFile(res.data.data);
                })
            },
            reset(){
                this.searchTime = [];
                delete this.queryInfo.dealerName;
                delete this.queryInfo.dealerNo;
                delete this.queryInfo.mobile;
                delete this.queryInfo.dtFrom;
                delete this.queryInfo.dtTo;
                delete this.queryInfo.dtFromFirst;
                delete this.queryInfo.dtToFirst;
                delete this.queryInfo.dtFromLatest;
                delete this.queryInfo.dtToLatest;
                delete this.queryInfo.custType;
                this.searchTime = [];
                this.firstSearchTime = [],
                this.lastSearchTime = [],
                this.getListData(this.pagination,true);
            }
        },
        mounted() {
            this.init();
        }
    }
</script>